export const listCustomerSubscriptions = `
   query listCustomerSubscriptions($filter: CustomerSubscriptionsFilterInput, $limit: Int, $nextToken: String, $sort: SortInput) {
       listCustomerSubscriptions(filter: $filter, limit: $limit, nextToken: $nextToken, sort: $sort) {
           items {
              id
              customerId
              customer {
                id
                name
              }
              items {
                items {
                  id
                  subscriptionId
                  priceId
                  price {
                    id
                    product {
                        name
                    }
                    amount
                    billingPeriod
                  }
                  quantity
                }
                nextToken
              }
              status
              created
              createdByUsername
              createdByUser {
                name
                givenName
                familyName
                email
              }
              updated
              updatedByUsername
           }
           nextToken
       }
   }
`;

export const getCustomerSubscription = `
   query getCustomerSubscription($id:ID!) {
       getCustomerSubscription(id:$id) {
         id
         customerId
         customer {
            id
            name
         }
         items {
           items {
             id
             subscriptionId
             priceId
             price {
               id
               product {
                   name
               }
               amount
               billingPeriod
             }
             quantity
           }
           nextToken
         }
         status
         created
         createdByUsername
         createdByUser {
           name
           givenName
           familyName
           email
         }
         updated
         updatedByUsername
       } 
}`;
